import { Icon } from '@iconify/react';
import { Button } from '@/components/shadcn/button';

interface PadelSubpageHeaderProps {
  title: string;
  subtitle?: string;
  onBack: () => void;
}

export default function PadelSubpageHeader({ title, subtitle, onBack }: PadelSubpageHeaderProps) {
  return (
    <header className="sticky top-0 z-20 -mx-4 mb-4 border-b border-gray-100 bg-white px-4 md:static md:mx-0 md:border-0 md:px-0">
      <div className="flex h-14 items-center gap-3">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="Kembali"
          onClick={onBack}
          className="h-9 w-9 rounded-full text-[#0E1726]"
        >
          <Icon icon="ph:arrow-left-bold" className="h-5 w-5" />
        </Button>
        <div className="min-w-0">
          <h1 className="truncate text-base font-extrabold text-[#0E1726]">{title}</h1>
          {subtitle && <p className="truncate text-xs text-gray-400">{subtitle}</p>}
        </div>
      </div>
    </header>
  );
}
